<template>
  <div class="row px-sm-4 px-md-4 px-lg-0 pt-sm-3">
    <div class="col-12 mb-2">
      <PageTitle title="Integração com a API" />  
    </div>
    <b-col cols="12" >
      <b-button 
          class="mr-3" 
          variant="danger"
          @click="$refs.videoManual.toggleOpen({ 
              url: 'https://www.youtube.com/watch?v=FefuV7YhXEk&list=PLW_y7yl6WbLvRvXmlcWDT7-Zi0jR-P721&index=11', 
              title: 'Integração com a API' 
          })"
          >
          <i class="fas fa-play mr-1"></i>
          Ver vídeo
      </b-button>
      <a
        class="btn btn-success"
        href="https://api.construp.com.br/assets/Integração com a API.pdf"
        target="_blank"
        download
        ><i class="fas fa-file-pdf c-white"></i> Baixar Manual</a
      >
      <b-button
        class="btn-warning ml-3 text-white"
        href="https://api.construp.com.br/assets/Doc_API.pdf"
        target="_blank"
        download
    >
        Baixar Documentação API
    </b-button>
    </b-col>

        <div class="col-12" v-if="valid == true && loading == false">
            <hr />
            <i class="fas fa-link fa-2x c-orange mr-2 mb-3"></i>
            <h4 class="text-uppercase c-orange font-weight-bold d-inline">
                Dados de integração com a API
            </h4>
            <div class="row">
                <div class="col-4">
                    <label>ID cliente</label>
                    <div class="input-group mb-2 mr-sm-2" @click="copyToClipboard(userId)">
                        <input type="text" class="form-control" v-model="userId" disabled>
                        <div class="input-group-prepend">
                            <div class="input-group-text" style="cursor:pointer;border: 1px solid #28a745;">
                                <i class="far fa-copy" style="color:#28a745;"></i>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-8">
                    <label>API token</label>
                    <div class="input-group mb-2 mr-sm-2" @click="copyToClipboard(tokenApi)">
                        <input type="text" class="form-control" v-model="tokenApi" disabled>
                        <div class="input-group-prepend">
                            <div class="input-group-text" style="cursor:pointer;border: 1px solid #28a745;">
                                <i class="far fa-copy" style="color:#28a745;"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-12" v-if="valid == false && loading == false">
            <hr />
            <i class="fas fa-paper-plane fa-2x c-orange mr-2 mb-3"></i>
            <h4 class="text-uppercase c-orange font-weight-bold d-inline">
                Solicitar integração com API
            </h4>
            <div class="row">
                <div class="col-12 text-center">
                    <button class="btn btn-success btn-block" @click="integrarApi()">Solicitar integração com API</button>
                </div>
            </div>
        </div>

        <div class="col-12">
            <hr />
            <i class="fas fa-sticky-note fa-2x c-orange mr-2 mb-3"></i>
            <h4 class="text-uppercase c-orange font-weight-bold d-inline">
                Requisições disponíveis na API
            </h4>

            <div class="row">
                <div class="col-12">
                    <h4 class="text-center">Cadastro e atualização de multiplos produtos na mesma requisição!</h4>
                    <label>URL de cadastro e atualização para multiplos produtos - (Method: POST)</label>
                    <div class="input-group mb-2 mr-sm-2" @click="copyToClipboard(urlMultiple)">
                        <input type="text" class="form-control" v-model="urlMultiple" disabled>
                        <div class="input-group-prepend">
                            <div class="input-group-text" style="cursor:pointer;border: 1px solid #28a745;">
                                <i class="far fa-copy" style="color:#28a745;"></i>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-xs-6 col-lg-6 col-md-12 col-sm-12 mb-4">
                    <h5><b>Descrição do payload - (Method: POST)</b></h5>
                    <p>"userId": "SEU_USERID_AQUI" <b style="color:red">Id do usuário *</b></p>
                    <p>"token": "SEU_TOKEN_AQUI" <b style="color:red">Token de acesso *</b></p>
                    <p>"selectedProducts": [  <b style="color:red">Array de produtos *</b> </p>
                        <p class="ml-2">{ </p>
                            <p class="ml-4">"product": "FITA VEDA ROSCA 18MX10M" <b>Nome do produto</b></p>
                            <p class="ml-4">"brand": "FORTLEV" <b>Marca do produto</b></p>
                            <p class="ml-4">"codBar": 789123456987 <b style="color:red">Código de barras *</b></p>
                            <p class="ml-4">"priceSalesFormat1": "10.90" <b style="color:red">Preço, os centavos dever ser separado por '.' e não por ',' *</b></p>
                            <p class="ml-4">"quantityStock": 15 <b>Quantidade de estoque</b></p>
                            <p class="ml-4">"codInterno": 45686 <b>Código interno do produto do sistema do lojista</b></p>
                            <p class="ml-4">"quantityValid": true <b>Ativar controle de estoque do produto</b></p>
                            <p class="ml-4">"withdrawalInOneDay": true <b>Produto disponível em estoque para entregar em 24 horas</b></p>
                            <p class="ml-4">"discont": 10 <b>Disconto em (%) referente ao produto</b></p>
                        <p class="ml-2">} </p>
                    <p>]</p>

                    <p style="color:red">Itens obrigatórios (*)</p>
                    <br>
                    <h4>Resposta da requisição</h4>
                    <p><b>error:</b> "Se ocorreu erro na requisição, <b>false</b> ou <b>true</b>!"</p>
                    <p><b>message:</b> "Mensagem de retorno da requisição",</p>
                    <p><b>inserted:</b> "Itens que foi incluido!"</p>
                    <p><b>updated:</b> "Itens que foi atualizado!"</p>
                    <p><b>waiting:</b> "Itens que a ConstrUp não tem no banco de dados, mas vai ser feito o cadastro e vinculado automaticamente após o cadastro pela parte da ConstUp"</p>
                    <p><b>waitingBind:</b> "Itens que já estão sendo aguardado o cadastro pela parte da ConstUp"</p>
                    <p><b>invalids:</b> "Itens que contem dados Inválidos para o cadastro"</p>
                </div>

                <div class="col">
                    <img src="@/assets/img/insert-products.png" alt="Multiplos produtos">
                </div>
            </div>

            <hr />

            <div class="row">
                <div class="col-12">
                    <h4 class="text-center">Cadastro de um único produto na mesma requisição!</h4>
                    <label>URL de cadastro para um produto - (Method: POST)</label>
                    <div class="input-group mb-2 mr-sm-2" @click="copyToClipboard(urlOneProduct)">
                        <input type="text" class="form-control" v-model="urlOneProduct" disabled>
                        <div class="input-group-prepend">
                            <div class="input-group-text" style="cursor:pointer;border: 1px solid #28a745;">
                                <i class="far fa-copy" style="color:#28a745;"></i>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-xs-6 col-lg-6 col-md-12 col-sm-12 mt-2 mb-4">
                    <h5><b>Descrição do payload - (Method: POST)</b></h5>
                    <p>"userId": "SEU_USERID_AQUI" <b style="color:red">Id do usuário *</b></p>
                    <p>"token": "SEU_TOKEN_AQUI" <b style="color:red">Token de acesso *</b></p>
                    <p>"product": "FITA VEDA ROSCA 18MX10M" <b>Nome do produto</b></p>
                    <p>"brand": "FORTLEV" <b>Marca do produto</b></p>
                    <p>"codBar": 789123456987 <b style="color:red">Código de barras *</b></p>
                    <p>"priceSalesFormat1": "10.90" <b style="color:red">Preço, os centavos dever ser separado por '.' e não por ',' *</b></p>
                    <p>"quantityStock": 15 <b>Quantidade de estoque</b></p>
                    <p>"codInterno": 45686 <b>Código interno do produto do sistema do lojista</b></p>
                    <p>"quantityValid": true <b>Ativar controle de estoque do produto</b></p>
                    <p>"withdrawalInOneDay": true <b>Produto disponível em estoque para entregar em 24 horas</b></p>
                    <p>"discont": 10 <b>Disconto em (%) referente ao produto</b></p>

                    <p style="color:red">Itens obrigatórios (*)</p>
                </div>

                <div class="col">
                    <img src="@/assets/img/insert-one-product.png" class="img-fluid" alt="Multiplos produtos">
                </div>
            </div>

            <hr />

            <div class="row">
                <div class="col-12">
                    <h4 class="text-center">Atualização de um único produto na mesma requisição!</h4>
                    <label>URL de atualização para um produto - (Method: PUT)</label>
                    <div class="input-group mb-2 mr-sm-2" @click="copyToClipboard(urlUpdateProduct)">
                        <input type="text" class="form-control" v-model="urlUpdateProduct" disabled>
                        <div class="input-group-prepend">
                            <div class="input-group-text" style="cursor:pointer;border: 1px solid #28a745;">
                                <i class="far fa-copy" style="color:#28a745;"></i>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-xs-6 col-lg-6 col-md-12 col-sm-12 mt-2 mb-4">
                    <h5><b>Descrição do payload - (Method: PUT)</b></h5>
                    <p>"userId": "SEU_USERID_AQUI" <b style="color:red">Id do usuário *</b></p>
                    <p>"token": "SEU_TOKEN_AQUI" <b style="color:red">Token de acesso *</b></p>
                    <p>"product": "FITA VEDA ROSCA 18MX10M" <b>Nome do produto</b></p>
                    <p>"brand": "FORTLEV" <b>Marca do produto</b></p>
                    <p>"codBar": 789123456987 <b style="color:red">Código de barras *</b></p>
                    <p>"priceSalesFormat1": "10.90" <b style="color:red">Preço, os centavos dever ser separado por '.' e não por ',' *</b></p>
                    <p>"quantityStock": 15 <b>Quantidade de estoque</b></p>
                    <p>"codInterno": 45686 <b>Código interno do produto do sistema do lojista</b></p>
                    <p>"quantityValid": true <b>Ativar controle de estoque do produto</b></p>
                    <p>"withdrawalInOneDay": true <b>Produto disponível em estoque para entregar em 24 horas</b></p>
                    <p>"discont": 10 <b>Disconto em (%) referente ao produto</b></p>

                    <p style="color:red">Itens obrigatórios (*)</p>
                </div>

                <div class="col">
                    <img src="@/assets/img/insert-one-product.png" class="img-fluid" alt="Multiplos produtos">
                </div>
            </div>
        </div>
        <VideoManual ref="videoManual"/>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import makeToast from '../../../mixins/makeToast';
import PageTitle from 'Components/PageTitle.vue';
import VideoManual from '@/components/VideoManual.vue';

export default {
    name: 'WaitingProduct',
    mixins: [makeToast],

    components: {
        PageTitle,
        VideoManual
    },

    data() {
        return {
            loading: false,
            valid: false,
            tokenApi: '',
            userId: '',
            urlMultiple: '',
            urlOneProduct: '',
            urlUpdateProduct: ''
        }
    },

    computed: {
        ...mapState(['token', 'dadosUsuario']),
    },

    created() {
        this.urlMultiple = process.env.VUE_APP_SHOPKEEPER_APP_API_URL+'insert-products';
        this.urlOneProduct = process.env.VUE_APP_SHOPKEEPER_APP_API_URL+'insert-one-product';
        this.urlUpdateProduct = process.env.VUE_APP_SHOPKEEPER_APP_API_URL+'update-product';
        this.validApi();
    },

    methods: {
        copyToClipboard(value) {
            navigator.clipboard.writeText(value);
            this.makeToast('Sucesso!', 'Copiado com sucesso!', 'success');
        },
        validApi() {
            this.$store.dispatch('startLoader');
            this.$store.dispatch('shopkeeper/getValidTokenLojistaApi', this.dadosUsuario.informacoes.id)
                .then((response) => {
                    if(response.data.status && response.data.status == true) {
                        this.get();

                        const id = this.dadosUsuario.id;
                        this.userId = id.toString(16);
                        this.valid = true;                        
                    }
                })
                .finally(() => {
                    this.$store.dispatch('endLoader');
                })
        },
        integrarApi() {
            this.$store.dispatch('startLoader');
            this.$store.dispatch('shopkeeper/integrarLojistaApi', this.dadosUsuario.informacoes.id)
                .then((response) => {
                    if(response.data.valid && response.data.valid == true) {
                        this.get();

                        const id = this.dadosUsuario.id;
                        this.userId = id.toString(16);
                        this.valid = true;                        
                    }
                })
                .finally(() => {
                    this.$store.dispatch('endLoader');
                })
        },
        get() {
            this.$store.dispatch('startLoader');
            this.$store.dispatch('shopkeeper/getTokenLojistaApi', this.dadosUsuario.id)
                .then((response) => {
                    if(response.data.token) {
                        this.tokenApi = response.data.token;
                    } else {
                        this.makeToast('Ops!', 'Não foi possível gerar o token!', 'danger');
                    }
                })
                .catch(() => {
                    this.makeToast('Ops!', 'Não foi possível gerar o token!', 'danger');
                })
                .finally(() => {
                    this.$store.dispatch('endLoader');
                })
        }
    }
}
</script>

<style scoped>

</style>
